import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  class: "w-full h-full",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<g clip-path=\"url(#a)\"><path fill=\"currentColor\" d=\"M10 5A5 5 0 1 0 0 5a5 5 0 0 0 10 0\"></path><path fill=\"#D0D5DD\" fill-rule=\"evenodd\" d=\"M19 0a5 5 0 1 0 0 10 5 5 0 0 0 0-10m-3 5a3 3 0 1 0 6 0 3 3 0 0 0-6 0M5 14a5 5 0 1 0 0 10 5 5 0 0 0 0-10m-3 5a3 3 0 1 0 6 0 3 3 0 0 0-6 0M14 19a5 5 0 1 1 10 0 5 5 0 0 1-10 0m5 3a3 3 0 1 1 0-6 3 3 0 0 1 0 6\" clip-rule=\"evenodd\"></path></g><defs><clipPath id=\"a\"><rect fill=\"#fff\" class=\"w-full h-full\"></rect></clipPath></defs>", 2)
const _hoisted_4 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }